export default {"src":"/_next/static/media/infos.f3bd9f94.svg","height":142,"width":142,"blurWidth":0,"blurHeight":0};